import type { HTMLAttributes } from 'react';
import {
  CONTENT_ICON_ALIASES,
  CONTENT_ICON_DEFINITIONS,
  CONTENT_ICON_SPRITE,
} from '../../utils/content-icon-catalog';

/** Legacy CMS names select reviewed SVG shapes; no font/CSS dependency. */
export function ContentIcon({ className = '', style, children: _children, ...props }: HTMLAttributes<HTMLSpanElement>) {
  const tokens = className.split(/\s+/);
  // The previous service stylesheet explicitly hid this unavailable Pro glyph.
  if (tokens.includes('fa-mirror')) return null;
  const token = tokens.find(token => token.startsWith('fa-') && CONTENT_ICON_ALIASES[token.slice(3)]);
  const name = token ? CONTENT_ICON_ALIASES[token.slice(3)] : 'circle-question';
  const definition = CONTENT_ICON_DEFINITIONS[name];
  return (
    <span
      aria-hidden="true"
      {...props}
      className={className}
      data-content-icon-wrapper="true"
      style={{ display: 'inline-block', height: '1em', lineHeight: 1, verticalAlign: '-.125em', flexShrink: 0, fontFamily: 'inherit', ...style }}
    >
      <svg aria-hidden="true" focusable="false" data-content-icon={name} viewBox={definition.viewBox}
        style={{ display: 'block', margin: '0 auto', width: `${definition.width}em`, height: '1em', fill: 'currentColor' }}>
        <use href={`${CONTENT_ICON_SPRITE}#${name}`} />
      </svg>
    </span>
  );
}
